import { Dialog } from "@/components/ui/dialog";
import { useDialogStore } from "@/hooks/useDialog";
import React from "react";

export function DialogProvider({ children }: { children: React.ReactNode }) {
    const { isOpen, activeDialog, closeDialog } = useDialogStore();
    
    // Get the dialog component from registered dialogs
    const DialogComponent = activeDialog && useDialogStore.getState().registeredDialogs[activeDialog.type];
    
    // Log for debugging
    React.useEffect(() => {
        if (isOpen) {
            console.log('Dialog is open:', {
                activeDialog,
                hasDialogComponent: !!DialogComponent,
                onSaveIsFunction: typeof useDialogStore.getState().onSave === 'function'
            });
        }
    }, [isOpen, activeDialog, DialogComponent]);

    return (
        <>
            {children}
            <Dialog 
                open={isOpen} 
                onOpenChange={(open) => {
                    if (!open) closeDialog();
                }}
            >
                {/* Render the dialog component if it exists */}
                {DialogComponent && activeDialog && (
                    <DialogComponent 
                        data={activeDialog.data || {}} 
                        onClose={closeDialog} 
                        onSave={useDialogStore.getState().handleSave} 
                    />
                )}
            </Dialog>
        </>
    );
} 